import React, {useState} from 'react';

import {RoundButton} from '@optimaxdev/design-system';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {FormattedAddressType} from 'desktop/types/addressType';

import {getFormattedAddress} from '../../store/selectors/shippingAddress/shippingAddress';
import {Addresses} from '../addresses/addresses';
import {DeliveryFormFields} from '../deliveryFormFields/deliveryFormFields';
import {DeliveryFormTitle} from '../deliveryFormTitle/deliveryFormTitle';

import s from './shippingAddress.scss';

type PropsType = {
    addresses: FormattedAddressType;
};

/**
 * Shipping Address for checkout
 *
 * @constructor
 */
const ShippingAddress: React.FC<PropsType> = ({addresses}) => {
    const [isEditMode, setEditMode] = useState(false);
    return (
        <>
            <AnimateHeight duration={500} height={isEditMode ? 'auto' : 0}>
                <div className={classNames(s.expanded, {[s.active]: isEditMode})}>
                    <DeliveryFormTitle isRequired>Shipping address</DeliveryFormTitle>
                    <DeliveryFormFields target="shippingAddress" />
                </div>
            </AnimateHeight>
            <AnimateHeight duration={500} height={isEditMode ? 0 : 'auto'}>
                <div className={classNames(s.collapsed, {[s.active]: !isEditMode})}>
                    <div className={s.header}>
                        <h2 className={s.title}>Shipping address</h2>
                        <RoundButton
                            className={s.button}
                            colorName="geyser"
                            onClick={() => setEditMode(!isEditMode)}
                            size="extraSmall"
                            type="button"
                            isFull
                        >
                            Edit
                        </RoundButton>
                    </div>
                    <Addresses addresses={addresses} />
                </div>
            </AnimateHeight>
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    addresses: getFormattedAddress(store),
});

export const ShippingAddressConnected = connect(mapStateToProps)(ShippingAddress);
